import React, {Component} from 'react';
import axios from "axios";

import inst from "../../../../assets/logos/instant_3.svg";
import up from "../../../../assets/logos/fleche_up.svg";
import down from "../../../../assets/logos/fleche_rouge.svg";
import acheter from "../../../../assets/logos/bouton_acheter.svg";

export default class Instants extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.user,
            id: this.props.id,
            instants: null,
        }
    }

    componentDidMount() {
        let url = import.meta.env.VITE_BACKEND_URL + '/instant/get';
        axios.post(url, {
                id: this.state.id,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + this.state.user.token
                }
            }).then(response => {
            this.setState({instants: response.data})
        }).catch(error => {
            console.log(error)
        })
    }
    formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }
    handleVideoSimple = (type, index) => {
        const {instants} = this.state;
        if(type === 'simple'){
            let video = instants[index];
            let url = "/video/" + video.video.token + "/" + video.startTime;
            window.location.href = url;
        }else{
            let video = instants[index];
            let url = "/instant/" + video.video.token + "/" + video.startTime;
            window.location.href = url;
        }
    }

    render() {
        return (
            <>
                {
                    this.state.instants !== null &&
                    this.state.instants.map((instant, index) => (
                        <div key={index} className="block_line">
                            <div className="image_block" onClick={() => this.handleVideoSimple('simple',index)}>
                                <img src={`${import.meta.env.VITE_BACKEND_URL_IMG}${instant.video.miniature}`} alt=""/>
                                <div className="round_background">
                                    <img src={inst} alt=""/>
                                </div>
                                <div className="time">
                                    <p>{this.formatTime(instant.startTime)}</p>
                                </div>
                            </div>
                            <div className="info_instant" onClick={() => this.handleVideoSimple('instant',index)}>
                                <div className="title_video">
                                    <p>{instant.video.title}</p>
                                    <p>{instant.price}€</p>
                                </div>
                                <div className="creator_block">
                                    <p>{instant.creator.nom_artiste}</p>
                                    <p><img src={up} alt=""/> +3</p>
                                </div>
                                <div className="message_video">
                                    <p>{instant.message}</p>
                                    <p>Plus d’informations sur le NFT</p>
                                </div>
                                <div className="block_button">
                                    <img src={acheter} alt=""/>
                                </div>
                            </div>
                        </div>

                    ))
                }
            </>
        );
    }

}